export default __webpack_public_path__ + "static/media/result_1.e2fe4422.jpg";